export class ChangeOrderStatusReqModel {
  OldAccessionNo: string;
  NewAccessionNo: string;
  EmpId: number;
}
